import { useParams } from 'react-router-dom'
import EditCompanyForm from './EditCompanyForm'
import { useGetCompaniesQuery } from './companiesApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditCompany = () => {
    useTitle('techCompanies: Edit Company')

    const { id } = useParams()

    const { username, isAdmin } = useAuth()

    const { company } = useGetCompaniesQuery("companiesList", {
        selectFromResult: ({ data }) => ({
            company: data?.entities[id]
        }),
    })


    if (!company) return <PulseLoader color={"#FFF"} />


    if (!isAdmin) {
            return <p className="errmsg">No access</p>
    }

    const content = <EditCompanyForm company={company} />

    return content
}
export default EditCompany